// Lightweight SEO/AEO helper — no dependency. Updates document title, meta tags,
// canonical link, and injects a per-page JSON-LD block. Google & answer engines
// execute JS, so client-set structured data is indexed.
import { useEffect } from "react";

// Production domain used for all canonical/OG URLs so crawlers index the right host.
export const SITE_URL = "https://paysignal.ai";

function setMeta(attr, key, content) {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function setCanonical(href) {
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

export function useSEO({ title, description, image, type = "website", canonical, jsonLd }) {
  useEffect(() => {
    // Always anchor canonical/OG to the production domain, regardless of the host serving the SPA.
    let path = window.location.pathname;
    if (canonical) {
      try { path = new URL(canonical).pathname; } catch (e) { /* keep current path */ }
    }
    const url = SITE_URL + path;
    if (title) document.title = title;
    setMeta("name", "description", description);
    setMeta("property", "og:title", title);
    setMeta("property", "og:description", description);
    setMeta("property", "og:type", type);
    setMeta("property", "og:url", url);
    setMeta("property", "og:image", image);
    setMeta("name", "twitter:card", "summary_large_image");
    setMeta("name", "twitter:title", title);
    setMeta("name", "twitter:description", description);
    setMeta("name", "twitter:image", image);
    setCanonical(url);

    let script;
    if (jsonLd) {
      script = document.createElement("script");
      script.type = "application/ld+json";
      script.id = "page-jsonld";
      script.text = JSON.stringify(jsonLd);
      const prev = document.getElementById("page-jsonld");
      if (prev) prev.remove();
      document.head.appendChild(script);
    }
    return () => { if (script) script.remove(); };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [title, description, image, type, canonical, JSON.stringify(jsonLd)]);
}
